export default __webpack_public_path__ + "static/media/Local tea at Mysore.a0534a74.jpg";